import axios from 'axios';
import React, { createContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen/LoadingScreen';
import { ENDPOINT, getJWT } from '../helpers/Helper';

export const ProductContext = createContext();

function ProductContextProvider(props) {
    const navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true);

        const jwt = getJWT();

        if(jwt) {
            axios.get(`${ENDPOINT}/products`, { headers: { Authorization: `Bearer ${jwt}` } })
                .then(res => {
                    setProducts(res.data);
                    setLoading(false);
                })
                .catch (err => {
                    alert(err.response.data.error);
                    setLoading(false);
                    navigate("/error")
                })
        } else {
            axios.get(`${ENDPOINT}/products`)
                .then(res => {
                    setProducts(res.data);
                    setLoading(false);
                })
                .catch (err => {
                    alert(err.response.data.error);
                    setLoading(false);
                    navigate("/error")
                })
        }

        

    }, [getJWT()])
    return (
        <React.Fragment>
            {
                loading ? <LoadingScreen /> : (
                    <ProductContext.Provider value={{ products }}>
                        {props.children}
                    </ProductContext.Provider>
                )
            }
        </React.Fragment>
        
    )
}

export default ProductContextProvider
